var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gl-relative"},[_c('gl-avatar',{attrs:{"label":_vm.user.name,"src":_vm.avatarUrl,"size":_vm.imgSize,"aria-hidden":"true","data-testid":"avatar-image"}}),_vm._v(" "),(_vm.hasMergeIcon)?_c('gl-icon',{staticClass:"merge-icon",attrs:{"aria-label":_vm.__('Cannot merge'),"name":"warning-solid"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }